import { useMutate } from '../../../core/hooks/useMutate';
import { BlockComment } from '../types/BlockComment';

export function useCreateBlockComment(ceremonyId: number, blockId: number) {
    return useMutate<BlockComment>(
        `ceremonies/${ceremonyId}/blocks/${blockId}/comments`,
        "POST",
    );
}
